import { ServerError } from 'global/helpers/requestError'

export const isQuoteAnswerNotFoundError = (error: unknown): boolean => {
  if (error instanceof ServerError) {
    return error.response.status === 404
  }
  return false
}

export const isQuoteExpiredError = (error: unknown): boolean => {
  if (error instanceof ServerError) {
    return error.response.status === 410
  }
  return false
}
